export const ConfirmDialogType = Object.freeze({ YesNo: 0, OKCancel: 1, YesNoCancel: 2 });

export function ConfirmDialog(options) {
    if (!options) {
        throw "options is required";
    }

    if (!options.callback) {
        throw "options.callback is required";
    }

    if (!options.message) {
        throw "options.message is required";
    }

    const bootboxOptions = {
        animate: false,
        callback: options.callback,
        message: options.message,
        title: undefined,
        size: undefined,
        buttons: undefined
    };

    if (options.title) {
        bootboxOptions.title = options.title;
    }

    if (options.size) {
        bootboxOptions.size = options.size;
    }

    const customDialogTypes = [ConfirmDialogType.YesNoCancel];
    const isCustomDialogType = (dialogType: any): boolean => customDialogTypes.includes(dialogType);

    const dialogType = options.dialogType || ConfirmDialogType.YesNo;
    if (isCustomDialogType(dialogType)) {

        if (dialogType === ConfirmDialogType.YesNoCancel) {
            const execCallback = (arg?: boolean): boolean => {
                if (options.callback) {
                    return options.callback.call(this, arg);
                }
                return true;
            };

            bootboxOptions.buttons = {
                yes: { label: "Yes", callback: (res) => execCallback(true), className: "btn-primary" },
                no: { label: "No", callback: (res) => execCallback(false) },
                cancel: { label: "Cancel", callback: (res) => execCallback(null) }
            };
        }

        bootbox.dialog(bootboxOptions);
        return;
    }

    switch (dialogType) {
        case ConfirmDialogType.OKCancel:
            bootboxOptions.buttons = { "confirm": { label: "OK" }, "cancel": { label: "Cancel" } };
            break;
        default:
            bootboxOptions.buttons = { "confirm": { label: "Yes" }, "cancel": { label: "No" } };
            break;
    }

    bootbox.confirm(bootboxOptions);
};
